import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthContextProvider } from "./Auth/AuthContext";
import { ContextProvider } from "./Context";
import AzureAuth from "./Auth/AzureAuth";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <ContextProvider>
        <AzureAuth>
          <App />
        </AzureAuth>
      </ContextProvider>
    </AuthContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();